export default __webpack_public_path__ + "static/media/male.e16031f0.png";